export default "__VITE_ASSET__CCFPEmx4__"